import React, { Fragment, Component } from 'react';
import b from 'b_';
import { RouteComponentProps } from 'react-router-dom';
import { Logo } from 'lego-on-react';

import { AppDataProps } from 'client/contexts/app-data';
import AppMenu from '@components/app-menu';
import SideNavContainer from '@components/side-nav-container';

import './header.css';

export interface SizeProps {
    isDesktop: boolean;
}

export interface DispatchProps {
    toggleSideNav(state: boolean): void;
}

export type Props = SizeProps & DispatchProps & RouteComponentProps<any> & AppDataProps;

const LegoLogo = (Logo as any);
const class_ = b.with('head');

export default class Header extends Component<Props> {
    public readonly state = {
        sideNavIsOpened: false
    };

    public shouldComponentUpdate() {
        return true;
    }

    public onHamburgerClick = () => {
        this.props.toggleSideNav(true);
    };

    public renderMenu() {
        const { appData } = this.props;

        return (
            <Fragment>
                {appData.headMenu.map(({ link, title, active }) => (
                    <a
                        key={title}
                        href={link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={active ? class_('item', { active: true }) : class_('item')}
                    >
                        {title}
                    </a>
                ))}
            </Fragment>
        );
    }

    public renderLogo() {
        // Потом в css media query решаем какое из них показывать
        return (
            <div className={class_('logo')}>
                <span className={class_('logo_medium')}>
                    <LegoLogo
                        name="en-w-63x27"
                        type="link"
                        url="https://yandex.com"
                    />
                </span>
                <span className={class_('logo_small')}>
                    <LegoLogo
                        name="en-84x36"
                        type="link"
                        url="https://yandex.com"
                    />
                </span>
            </div>
        );
    }

    public render() {
        const { location, isDesktop } = this.props;
        const appMenuWithBackground = location.pathname !== '/';

        return (
            <Fragment>
                <div className={class_()}>
                    <div className={class_('light')}>
                        {this.renderLogo()}
                        <div
                            className={class_('hamburger')}
                            onClick={this.onHamburgerClick}
                        >
                            <span className={class_('hamburger-line')} />
                            <span className={class_('hamburger-line')} />
                            <span className={class_('hamburger-line')} />
                        </div>
                    </div>
                    {isDesktop && (
                        <div className={class_('menu')}>
                            {this.renderMenu()}
                        </div>
                    )}
                </div>
                <AppMenu
                    withBackground={appMenuWithBackground}
                />
                <SideNavContainer
                    togglerClass={class_('hamburger')}
                />
            </Fragment>
        );
    }
}
